import React, { useCallback, useState } from 'react'
import logo from '../assests/logo.png'
import { RiMenuFill } from "react-icons/ri";
import { MdOutlineClose } from "react-icons/md";
export default  function NavBar() {
    const [nav , setNav] = useState(false)
    const show = () =>{
        setNav(true)
    }
    const close =()=>{
        setNav(!nav)
    }
  return (
    <div className='max-w-[1200px] mx-auto flex justify-between items-center  mt-2 px-4 py-2  z-40'>
        <img src={logo} alt="Logo here"  className='w-[150px] h-[100px] p-1'/>
        <div className='flex  justify-center items-center space-x-5'>
        <ul className="hidden md:flex space-x-12 ">
            <a href="#About"><li   className='text-lg text-[#ECF0F1] hover:text-[#C0392B] hover:border-b-2 ease-in duration-150'>About</li></a>
            <a href="#Reviews"><li  className='text-lg text-[#ECF0F1] hover:text-[#C0392B] hover:border-b-2 ease-in duration-150'>Reviews</li></a>
            <a href="#Portfolio"><li  className='text-lg text-[#ECF0F1] hover:text-[#C0392B] hover:border-b-2 ease-in duration-150'>Portfolio</li></a>
        </ul>
        <a href="#Contact"><button  className='hidden md:flex text-[#ECF0F1]  text-lg rounded-lg bg-[#C0392B] px-4 py-1 hover:text-[#C0392B] hover:bg-white ease-in duration-100 hover:animate-pulse '>Contact</button></a>
        </div>
        <div className=' md:hidden '>
            {!nav ? <RiMenuFill className='text-white ' size={30} onClick={show}/> : <MdOutlineClose className='text-white fixed top-10 z-30 right-6' size={30} onClick={close}/>}
        </div>
        <div className={nav ? 'fixed text-[#ECF0F1]  items-center text-center w-full top-20  bg-[#C0392B]  bg-opacity-80  inset-0 z-50 h-[300px] ' : 'hidden'}>
            <ul className='md:hidden flex justify-between items-center flex-col space-y-3 text-center text-2xl mt-2 ease-out duration-300 '>
                <a href="#About"  ><li  onClick={close} className='hover:text-[#C0392B] hover:border-l-2 ease-in duration-150 border-b-4' >About</li></a>
                <a href="#Reviews" ><li  onClick={close}  className='hover:text-[#C0392B] hover:border-l-2 ease-in duration-150 border-b-4' >Reviews</li></a>
                <a href="#Portfolio" ><li  onClick={close}  className='hover:text-[#C0392B] hover:border-l-2 ease-in duration-150 border-b-4' >Portfolio</li></a>
                <a href="#Contact" ><li  onClick={close}  className='hover:text-[#C0392B] hover:border-l-2 ease-in duration-150 z-30 border-b-4' > Contact</li></a>
            </ul>
        </div>
    </div>
  )
}
